<script lang="ts">
    import type {FondFieldTypeDefinitions} from 'src/features/record/field-types/types';
    import {onMount} from 'svelte';
    import {getInjector} from 'core/svelte-context/context';
    import {createSearchFieldTypeFiltersContext} from 'src/features/search/kp-search-field-type-filter/search-field-type-filters.context';
    import {exists} from 'shared/utils/custom-utils';
    import {FieldTypeDataService} from 'src/features/record/field-types/field-type-data.service';

    export let fondId: number;
    export let fieldTypeDefinitions: FondFieldTypeDefinitions | null = null;

    const fieldTypeDataService = getInjector().getByClass(FieldTypeDataService);
    const context = createSearchFieldTypeFiltersContext();

    onMount(async () => {
        if (exists(fieldTypeDefinitions)) {
            context.setFieldTypeDefinitions(fieldTypeDefinitions);
            return;
        }

        const fondFieldTypeDefinitions = await fieldTypeDataService.loadFondFieldTypeDefinitions(fondId);
        context.setFieldTypeDefinitions(fondFieldTypeDefinitions);
    });
</script>

<slot/>